import tickets from "./tickets.component";
import ticketsUrls from "./tickets.urls";
import TicketsTransforms from "./tickets.transforms";

const ticketsModule = angular
  .module("app.components.tickets", [])
  .component("ticketsPage", tickets)
  .service("TicketsTransforms", TicketsTransforms)
  .config(ticketsUrls);

export default ticketsModule;



// WEBPACK FOOTER //
// ./src/pages/tickets/tickets.module.js